import { Grid, Typography } from '@mui/material';
import { Fragment, useContext } from 'react';
import TopHeaderFormView from './form/TopHeaderFormView';
import MemberCardView from './card/MemberCardView';
import LedgerListView from './ledger/LedgerListView';
import RadioButton from '../../../../constants/RadioBtn';
import { memterStatusOptions } from '../../../../constants/Options';
import { BillingContext } from '../../../../context/BillinEntryContext';
import TransactionFormView from './form/TransactionFormView';
import RightTranFormView from './form/RightTranFormView';
import useFetchSubData from '../../../../helpers/useSubFetch';
import AppURL from '../../../../constants/AppURL';

const BillingEntryMainFormView = () => {
    const context = useContext(BillingContext);
    const { data, loading, error } = useFetchSubData(AppURL.AccountURL + `account/single/user/amount/view/?member_sn=${context?.values?.member_sn}&deposit_year=${context?.values.deposit_year}&deposit_month=${context?.values.deposit_month}`, (context?.values?.member_sn, context?.values.deposit_month, context?.values.deposit_year));
    if (!context) {
        return <Typography>Error: Context not available</Typography>;
    }
    const { values, handleChange } = context;
    return (
        <Fragment>
            <Grid container spacing={2}>
                <Grid item xl={9} md={9} lg={9} sm={12} xs={12}>
                    <Grid container columnSpacing={1} rowSpacing={1}>
                        <Grid item xl={12} md={12} lg={12} sm={12} xs={12}>
                            <TopHeaderFormView bill_no={data?.next_bill_no || ""} />
                        </Grid>
                        <Grid item xl={12} md={12} lg={12} sm={12} xs={12}>
                            <LedgerListView />
                        </Grid>
                        <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                            <div className="bg-slate-200 dark:bg-sky-900 px-1 py-1 rounded-md">
                                <div className="border border-slate-400 dark:border-sky-700 border-dashed px-2 rounded-md">
                                    <RadioButton
                                        options={memterStatusOptions}
                                        name="meter_status"
                                        selectedValue={data?.meter_status?.[0]?.meter_status?.toString() || "0"}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </Grid>
                        <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                            <TransactionFormView data={data} />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xl={3} md={3} lg={3} sm={12} xs={12}>
                    <Grid container spacing={1}>
                        <Grid item xl={12} md={12} lg={12} sm={12} xs={12}>
                            <MemberCardView marga_tole_name={values.marga_tole_name ?? ""} total_amt={values.member_sn === 0 ? 0 : data?.mahasul_total_amt} mem_name={values.mem_name ?? ""} member_sn={values.member_sn?.toString()} />
                        </Grid>
                        <Grid item xl={12} md={12} lg={12} sm={12} xs={12}>
                            <RightTranFormView data={data} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Fragment>
    );
};

export default BillingEntryMainFormView;
